/**
 * @generated SignedSource<<003560f15de2b62fa93ee71349ca29d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TestCustomMcpServerOverridesInput = {
  authType?: string | null | undefined;
  credentials?: string | null | undefined;
  id: any;
  url?: string | null | undefined;
};
export type EditMcpServerRouteTestOverridesMutation$variables = {
  input: TestCustomMcpServerOverridesInput;
};
export type EditMcpServerRouteTestOverridesMutation$data = {
  readonly testCustomMcpServerOverrides: {
    readonly error: string | null | undefined;
    readonly success: boolean;
    readonly tools: ReadonlyArray<string>;
  };
};
export type EditMcpServerRouteTestOverridesMutation = {
  response: EditMcpServerRouteTestOverridesMutation$data;
  variables: EditMcpServerRouteTestOverridesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TestConnectionPayload",
    "kind": "LinkedField",
    "name": "testCustomMcpServerOverrides",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMcpServerRouteTestOverridesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMcpServerRouteTestOverridesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db678a4b60a8e4e6deeb18fc225d1a0c",
    "id": null,
    "metadata": {},
    "name": "EditMcpServerRouteTestOverridesMutation",
    "operationKind": "mutation",
    "text": "mutation EditMcpServerRouteTestOverridesMutation(\n  $input: TestCustomMcpServerOverridesInput!\n) {\n  testCustomMcpServerOverrides(input: $input) {\n    success\n    tools\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b8741ceb553b9675f1d0590406e8e56";

export default node;
